
import React from "react";
import styles from "../../assets/style.module.css";

export interface LogoBarProps {
    logos: string[];
}

function LogoBar({ logos }: LogoBarProps) {

    // the list is rendered twice so the marquee can loop seamlessly
    const loop = [...logos, ...logos];

    return (<section className={styles["logo-bar"]}>
        <div className={styles["logo-bar-track"]} style={{ animationDuration: `${Math.max(logos.length, 4) * 5}s` }}>
            {loop.map((l, i) => (<div key={`${l}-${i}`} className={styles["logo-bar-item"]} aria-hidden={i >= logos.length}>
                <img src={l} alt="" loading="lazy" />
            </div>))}
        </div>
    </section>);
}

export default LogoBar;
